import EstoqueNav from './components/Nav';
import EstoqueOverview from './overview/Overview';
import EstoqueItems from './items/Items';
import EstoqueItemDetail from './items/ItemDetail';
import EstoqueMovement from './movements/NewMovement';
import EstoqueRecipes from './recipes/Recipes';
import EstoqueReports from './reports/Reports';
import { useParamsContext } from '../../contexts/ParamsContext';

export default function Estoque() {
    const { action, id } = useParamsContext();
    const current = action || 'overview';

    let content = <EstoqueOverview />;

    switch (current) {
        case 'items':
            content = <EstoqueItems />;
            break;
        case 'detail':
            content = id ? <EstoqueItemDetail /> : <EstoqueItems />;
            break;
        case 'movement':
            content = <EstoqueMovement />;
            break;
        case 'recipes':
            content = <EstoqueRecipes />;
            break;
        case 'reports':
            content = <EstoqueReports />;
            break;
        case 'overview':
        default:
            content = <EstoqueOverview />;
            break;
    }

    return (
        <div className="sf-page flex flex-col gap-4 px-2">
            {/* O menu lateral assume a navegacao acima de 1024px. */}
            <div className="min-[1025px]:hidden">
                <EstoqueNav />
            </div>
            {content}
        </div>
    );
}
